export default {"src":"/_next/static/media/epcc_icon.f5f9dbe9.svg","height":32,"width":28,"blurWidth":0,"blurHeight":0};